module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/b0101-answer/b0101-answer.component.css
// module id = ./src/app/b0101-answer/b0101-answer.component.css
// module chunks = main